import React from "react";
import { Link, useHistory } from "react-router-dom";
import Loading from "../../loading/Loading";
import { getAllBlocks, getBlockInformation } from "../../services/getAPIs";
import SearchHash from "../Common/SearchHash/SearchHash";
import "./home-transaction.style.scss";
export default function HomeTransaction({ setHideHeader }) {
  const history = useHistory();
  const [blockList, setBlockList] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [allBlocks, setAllBlocks] = React.useState(false);
  const [blockInfo, setBlockInfo] = React.useState();

  const setUpBlockInfo = async () => {
    try {
      let res = await getBlockInformation();
      if (res.data.success) {
        setBlockInfo(res.data.data);
      } else {
      }
    } catch (error) {}
  };

  const setUpBlockList = async () => {
    let res;
    try {
      res = await getAllBlocks();
      if (res.data.success) {
        setBlockList(res.data.data);
      } else {
        setBlockList(res.data);
      }
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };
  const dateDifference = (date) => {
    let current = new Date().toISOString();
    let given = new Date(date);
    let one = new Date(current);
    let two = new Date(given);
    let res = Math.abs(one - two) / 1000;
    let days = Math.floor(res / 86400);
    let hours = Math.floor(res / 3600) % 24;
    let minutes = Math.floor(res / 60) % 60;
    let seconds = res % 60;
    if (!days && !hours && !minutes) {
      return `${parseInt(seconds)} seconds ago`;
    } else if (!days && !hours) {
      return `${minutes} minutes ago`;
    } else if (!days) {
      return `${hours} hours ago`;
    } else {
      return `${days} days ago`;
    }
  };
  React.useEffect(() => {
    setUpBlockList();
    setHideHeader();
    setUpBlockInfo();
  }, []);
  return (
    <div className="home-transaction-main">
      <section className="home-transaction-search">
        <div className="token-search-wrapper">
          <h2>The Ethereum Blockchain Explorer</h2>
          <div className="search-engine-wrapper">
            <SearchHash />
          </div>
        </div>
      </section>
      <div className="home-transaction-body">
        <div className="home-transaction-table-wrappers">
          <div className="ethereum-info">
            <div>
              <p>Hash Rate</p>
              <h6>{blockInfo?.hashRate || "0.00 h/s"}</h6>
            </div>
            <div>
              <p>Transactions</p>
              <h6>{blockInfo?.transcations || 0}</h6>
            </div>
            <div>
              <p>Difficulty</p>
              <h6>{blockInfo?.difficulty || 0.0}</h6>
            </div>
            <div>
              <p>Merkle Root</p>
              <h6 title={blockInfo?.merkleRoot}>{blockInfo?.merkleRoot}</h6>
            </div>
          </div>
          <div className="ethereum-table-blocks">
            <div className="ethereum-blocks">
              <div className="ethereum-block-header">
                <h5>Latest Blocks</h5>
              </div>
              <div
                style={allBlocks ? { height: "auto" } : {}}
                className="ethereum-block-body"
              >
                {loading ? (
                  <Loading />
                ) : (
                  blockList.map((obj, num) => (
                    <div className="single-block">
                      <div className="s-b-left">
                        <button>{num + 1}</button>
                        <div>
                          <p>
                            Hash{" "}
                            <span
                              onClick={() =>
                                history.push(`/home/transaction/${obj.hash}`)
                              }
                            >
                              {obj.hash}
                            </span>
                          </p>
                          <span>{dateDifference(obj.timeStamp)}</span>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
              <div className="ethereum-block-footer">
                <button onClick={() => setAllBlocks(!allBlocks)}>
                  {allBlocks ? "View Few Blocks" : "View All Blocks"}
                </button>
              </div>
            </div>
            <div className="ethereum-block-chart"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
